import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientAddPage } from './patient-add';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    PatientAddPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientAddPage),
    ComponentsModule
  ],
})
export class PatientAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-add/patient-add.module.ts